export const DBSchema = [
  {
    name: 'touchpos_disable_local_database',
    initialValue: '',
    input: {
      placeholder: 'Disable local database support for fast product search',
      className: 'touchpos_disable_local_database',
      label: 'Disable local database support for fast product search',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_allow_offline_mode',
    initialValue: '',
    input: {
      placeholder: 'Allow offline mode (Berlin POS)',
      className: 'touchpos_allow_offline_mode',
      label: 'Allow offline mode (Berlin POS)',
      type: 'checkbox',
    },
  },
];

export const DisplaySchema = [
  {
    name: 'touchpos_enable_customer_display_application',
    initialValue: '',
    input: {
      placeholder: 'Enable customer display application',
      className: 'touchpos_enable_customer_display_application',
      label: 'Enable customer display application',
      type: 'checkbox',
    },
  },
  {
    name: 'da_disable_discount_display',
    initialValue: '',
    input: {
      placeholder: 'Disable show of discount',
      className: 'da_disable_discount_display',
      label: 'Disable show of discount',
      type: 'checkbox',
    },
  },
  {
    name: 'customer_display_custom_panel',
    initialValue: '',
    input: {
      placeholder: 'Source (HTML)',
      className: 'customer_display_custom_panel',
      label: 'Display right panel source:',
      type: 'input',
      as: 'textarea',
      cols: 30,
      rows: 5,
    },
  },
];
